import type { ButtonHTMLAttributes, PropsWithChildren, ReactNode } from "react";
import { LoaderCircle, X } from "lucide-react";

export function Button({
  children,
  variant = "primary",
  loading,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: "primary" | "secondary" | "danger" | "ghost"; loading?: boolean }) {
  return (
    <button className={`button button--${variant}`} disabled={props.disabled || loading} {...props}>
      {loading ? <LoaderCircle className="spin" size={18} /> : null}
      {children}
    </button>
  );
}

export function Card({ children, className = "" }: PropsWithChildren<{ className?: string }>) {
  return <section className={`card ${className}`}>{children}</section>;
}

export function EmptyState({ icon, title, text, action }: { icon: ReactNode; title: string; text: string; action?: ReactNode }) {
  return (
    <div className="empty-state">
      <div className="empty-state__icon">{icon}</div>
      <h3>{title}</h3>
      <p>{text}</p>
      {action}
    </div>
  );
}

export function Modal({ children, title, onClose }: PropsWithChildren<{ title: string; onClose(): void }>) {
  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <div className="modal" role="dialog" aria-modal="true" aria-label={title}>
        <header className="modal__header">
          <h2>{title}</h2>
          <button className="icon-button" onClick={onClose} aria-label="Закрыть"><X size={20} /></button>
        </header>
        {children}
      </div>
    </div>
  );
}

export function Avatar({ name, src, size = 44 }: { name: string; src?: string; size?: number }) {
  return src ? (
    <img className="avatar" src={src} alt="" style={{ width: size, height: size }} />
  ) : (
    <div className="avatar avatar--fallback" style={{ width: size, height: size }}>{name.trim().charAt(0).toUpperCase()}</div>
  );
}

export function Spinner({ label = "Загрузка…" }: { label?: string }) {
  return <div className="page-spinner"><LoaderCircle className="spin" /><span>{label}</span></div>;
}

export function Toast({ message, onClose }: { message: string; onClose(): void }) {
  return <div className="toast" role="status"><span>{message}</span><button onClick={onClose}><X size={16} /></button></div>;
}

export const formatDate = (value: string): string =>
  new Intl.DateTimeFormat("ru-RU", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Saratov" }).format(new Date(value));

